function o(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
export {
  o as default
};
